<template>
  <BaseLink
    class="feed-item-action-button d-flex align-items-center gap-xxs gap-md-xs color-pewter"
    :class="{ highlight, disabled }"
    :disabled
    role="button"
    tabindex="0"
    @keydown.enter="onClick"
    @keydown.space="onClick"
    @click="onClick">
    <slot name="icon"/>
    {{ text }}
  </BaseLink>
</template>

<script setup>
import BaseLink from '@shared/components/BaseLink.vue'

const props = defineProps({
  text: {
    type: String,
    required: true
  },
  highlight: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['click'])
function onClick (event) {
  if (props.disabled) {
    event.stopPropagation()
    return
  }
  emit('click', event)
}
</script>

<style lang="scss" scoped>
.feed-item-action-button {
  font-size: $small-text-font-size;

  &:not(.disabled) {
    cursor: pointer;

    &:hover, &:focus {
      color: $plum !important;
    }

    &:focus {
      outline: none;
      box-shadow: 0 0 0 2px rgba($plum, 0.3);
      border-radius: 2px;
    }
  }
  &.disabled {
    cursor: default;
    pointer-events: none;
    opacity: 0.6;
  }

  --icon-size: 20px;
  @include media-tablet-or-larger() {
    --icon-size: 24px;
  }
  :slotted(svg) {
    width: var(--icon-size);
    height: var(--icon-size);
  }

  &.highlight :slotted(svg) {
    color: $plum;
  }
}
</style>